import { KeyValue } from '@/main/models/common';
import { WarehouseFilterRequest } from '@/main/models/request';

export enum WarehouseTypes {
  GET_WAREHOUSE = '@warehouse/GET_WAREHOUSE',
  SAVE_WAREHOUSE = '@warehouse/SAVE_WAREHOUSE',
  RESET_REDUCER_WAREHOUSE = '@warehouse/RESET_REDUCER_WAREHOUSE'
}

export interface WarehouseState {
  readonly warehouse: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetWarehouse {
  type: typeof WarehouseTypes.GET_WAREHOUSE;
  payload: {
    request: WarehouseFilterRequest;
  };
}

export interface SaveWarehouse {
  type: typeof WarehouseTypes.SAVE_WAREHOUSE;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerWarehouse {
  type: typeof WarehouseTypes.RESET_REDUCER_WAREHOUSE;
}

export type WarehouseActionTypes =
  | GetWarehouse
  | SaveWarehouse
  | ResetReducerWarehouse;

